"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Svg = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Svg = exports.Svg = _styledComponents["default"].svg.withConfig({
  displayName: "Svg",
  componentId: "sc-6c3c1v-0"
})(["fill:", ";stroke:transparent;"], function (props) {
  return props.$useBrandColor ? _encoreFoundation.green157 : (0, _index.cssColorValue)(props.$semanticColor);
});